import React from "react";
import {
    Card,
    Table,
    Divider
} from "antd";
import {
    Link,
} from "react-router-dom";

import memory from "../../../../../utils/memory";
import LinkButton from "../../../../../components/link-button";
import tools from "../../../../../utils/tools";
import {adminApi} from "../../../../../api";

const {reqRoleList} = adminApi;

export default class RoleList extends React.Component {
    state = {
        data: [],
        pagination: {},
        loading: false
    };

    handleTableChange = (pagination, filters, sorter) => {
        const pager = {...this.state.pagination};
        pager.current = pagination.current;
        pager.pageSize = pagination.pageSize;
        this.setState({
            pagination: pager
        });
        let tmpFilters = {...filters};
        for(let item in tmpFilters) {
            if(tmpFilters[item]) {
                if(typeof(tmpFilters[item]) !== 'string' && item !== 'tags') {
                    tmpFilters[item] = tmpFilters[item][0];
                }
            }
        }
        let params = {
            page: pagination.current,
            node: pagination.pageSize,
            ...tmpFilters,
        };
        this.getRoleList(params);
    }

    columns = [
        {
            title: 'No.',
            dataIndex: 'number',
            key: 'number',
        },
        {
            title: '角色',
            dataIndex: 'name',
            key: 'name',
        },
        {
            title: 'type',
            dataIndex: 'type',
            key: 'type'
        },
        {
            title: '权限数',
            dataIndex: 'rights',
            key: 'rights'
        },
        {
            title: '创建时间',
            dataIndex: 'create_time',
            key: 'create_time',
        },
        {
            title: '操作',
            dataIndex: 'option',
            valueType: 'option',
            render: (_, record, index) => {
                return (
                    <span>
                        <Link to={`/admin/authority/role/edit/${record.key}`}>详情</Link>
                        <Divider type="vertical" />
                        <Link to={`/admin/authority/role/right/${record.key}`}>设置权限</Link>
                    </span>
                );
            }
        },
    ];

    getRoleList = async (params = {}) => {
        this.setState({
            loading: true
        });
        const response = await reqRoleList(params);
        const pagination = {...this.state.pagination};
        const data = response.data;
        pagination.total = data.page.total;
        pagination.pageSize = data.page.node;
        pagination.current = data.page.current;
        let newData = [];
        for(let i = 0; i < data.data.length; i++) {
            const item = data.data[i];
            let obj = {
                key: item._id,
                number: (data.page.current-1)*data.page.node + i + 1,
                name: item.name,
                type: item.type,
                rights: item.rights || 0,
                create_time: tools.unixToTime((new Date(item.create_at)).getTime()/1000),
            };
            newData.push(obj);
        }

        this.setState({
            loading: false,
            data: newData,
            pagination
        });
    };

    componentDidMount() {
        this.getRoleList({
            page: 1,
        });
    }

    render() {
        return (
            <Card
                title="角色列表"
                bordered={false}
                extra={<LinkButton to="/admin/authority/role/add" txt="添加角色" />}
            >
                <Table
                    columns={this.columns}
                    dataSource={this.state.data}
                    pagination={{...this.state.pagination, showSizeChanger: true}}
                    loading={this.state.loading}
                    onChange={this.handleTableChange}
                    scroll={{ x: 'max-content' }} // 加上这条  横向滚动  支持此属性的浏览器内容就不会换行了
                    size={memory.is_mobile ? 'small' : 'middle'}
                />
            </Card>
        );
    }
}